import type { PolymorphicRef } from '@sds-system/types';
import type { ElementType } from 'react';
import { forwardRef } from 'react';
import { StyledTypographyRoot } from './Typography.styled';
import type { TypographyComponent, TypographyProps } from './Typography.types';

export const Typography: TypographyComponent = forwardRef(
  <C extends ElementType = 'span'>(
    { fontType = 'body.regular', color, ...props }: TypographyProps<C>,
    ref: PolymorphicRef<C>,
  ) => {
    return <StyledTypographyRoot color={color} fontType={fontType} {...props} ref={ref} />;
  },
);
